import { Building2, Calendar, Globe, Landmark, MapPin, Users } from "lucide-react";
import { CompanyInfoItem } from "./CompanyInfoItem";
import { COMPANY_INFO_FIELDS } from "../../constants";

interface CompanyInfoGridProps {
  data: {
    company_name: string | null;
    founded: string | null;
    headquarters: string | null;
    no_of_employees: string | null;
    ownership: string | null;
    primary_domain: string | null;
  };
  className?: string;
}

const iconMap: Record<string, React.ReactNode> = {
  Building2: <Building2 className="w-5 h-5" />,
  Calendar: <Calendar className="w-5 h-5" />,
  MapPin: <MapPin className="w-5 h-5" />,
  Users: <Users className="w-5 h-5" />,
  Landmark: <Landmark className="w-5 h-5" />,
  Globe: <Globe className="w-5 h-5" />,
};

/**
 * Format employee count to display as "~ 1385 employees"
 */
const formatEmployeeCount = (count: string | null): string | null => {
  if (!count) return null;
  return `~ ${count} employees`;
};

export const CompanyInfoGrid = ({ data, className = "" }: CompanyInfoGridProps) => {
  return (
    <ul
      className={`grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 list-none p-0 m-0 ${className}`}
      aria-label="Company Information"
    >
      {COMPANY_INFO_FIELDS.map((field) => {
        const value = field.key === 'no_of_employees'
          ? formatEmployeeCount(data[field.key])
          : data[field.key];

        // Make primary_domain clickable
        const isLink = field.key === 'primary_domain';

        return (
          <li key={field.key}>
            <CompanyInfoItem
              icon={iconMap[field.icon]}
              label={field.label}
              value={value}
              isLink={isLink}
            />
          </li>
        );
      })}
    </ul>
  );
};
